// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WRGD","content":"styles_content__C5EF_","tableWrap":"styles_tableWrap__1-T-u"};